/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentMethodOverridableConfiguration } from './PaymentMethodOverridableConfiguration';
import {
    PaymentMethodOverridableConfigurationFromJSON,
    PaymentMethodOverridableConfigurationFromJSONTyped,
    PaymentMethodOverridableConfigurationToJSON,
    PaymentMethodOverridableConfigurationToJSONTyped,
} from './PaymentMethodOverridableConfiguration';

/**
 * 
 * @export
 * @interface EnsurePaymentMethodForLocationRequest
 */
export interface EnsurePaymentMethodForLocationRequest {
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof EnsurePaymentMethodForLocationRequest
     */
    enabledInApps?: Set<FavritApp>;
    /**
     * 
     * @type {PaymentMethodOverridableConfiguration}
     * @memberof EnsurePaymentMethodForLocationRequest
     */
    overridableConfiguration?: PaymentMethodOverridableConfiguration;
    /**
     * 
     * @type {string}
     * @memberof EnsurePaymentMethodForLocationRequest
     */
    authenticatedUserEmail: string;
}

/**
 * Check if a given object implements the EnsurePaymentMethodForLocationRequest interface.
 */
export function instanceOfEnsurePaymentMethodForLocationRequest(value: object): value is EnsurePaymentMethodForLocationRequest {
    if (!('authenticatedUserEmail' in value) || value['authenticatedUserEmail'] === undefined) return false;
    return true;
}

export function EnsurePaymentMethodForLocationRequestFromJSON(json: any): EnsurePaymentMethodForLocationRequest {
    return EnsurePaymentMethodForLocationRequestFromJSONTyped(json, false);
}

export function EnsurePaymentMethodForLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnsurePaymentMethodForLocationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabledInApps': json['enabledInApps'] == null ? undefined : (new Set((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'overridableConfiguration': json['overridableConfiguration'] == null ? undefined : PaymentMethodOverridableConfigurationFromJSON(json['overridableConfiguration']),
        'authenticatedUserEmail': json['authenticatedUserEmail'],
    };
}

export function EnsurePaymentMethodForLocationRequestToJSON(json: any): EnsurePaymentMethodForLocationRequest {
    return EnsurePaymentMethodForLocationRequestToJSONTyped(json, false);
}

export function EnsurePaymentMethodForLocationRequestToJSONTyped(value?: EnsurePaymentMethodForLocationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabledInApps': value['enabledInApps'] == null ? undefined : (Array.from(value['enabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'overridableConfiguration': PaymentMethodOverridableConfigurationToJSON(value['overridableConfiguration']),
        'authenticatedUserEmail': value['authenticatedUserEmail'],
    };
}

